// extracted by mini-css-extract-plugin
module.exports = {"container":"Events_fasting_container__3-74D","item":"Events_fasting_item__18yMN","workoutContainer":"Events_fasting_workoutContainer__3OR2j"};